export default __webpack_public_path__ + "static/media/more-services-1.f18b783b.svg";